import { type ReactNode } from "react";

import { constants, Banner } from "@newsela/angelou";

import LockBox from "./no-access-2.svg?component";
import {
  bannerBodyStyles,
  bannerRootStyles,
  bannerTitleStyles,
  childWrapperStyles,
  iconStyles,
  veilWrapperStyles,
} from "./Veil.styles";

export interface VeilProps {
  children: ReactNode;
  isVeiled: boolean;
  title: string;
  bodyText: string;
}

export const Veil = (props: VeilProps) => {
  const { bodyText, children, isVeiled, title } = props;
  return isVeiled ? (
    <>
      <div css={veilWrapperStyles}>
        <Banner
          title={title}
          body={bodyText}
          bannerType={Banner.types.custom}
          __cssFor={{
            root: bannerRootStyles,
            title: bannerTitleStyles,
            body: bannerBodyStyles,
            Icon: {
              root: iconStyles,
            },
          }}
          customConfig={{
            SvgComponent: LockBox,
            colors: {
              primary: constants.colors.ui.white[700],
              foregroundProfile: Banner.foregroundProfiles.dark,
            },
          }}
        />
      </div>
      <div css={childWrapperStyles} aria-hidden="true" {...{ inert: "" }}>
        {children}
      </div>
    </>
  ) : (
    <>{children}</>
  );
};

export default Veil;
